import { gql } from '@apollo/client';
import list from './List';
import create from './Create';
import show from './Show';
import edit from './Edit';

export default {
  name: 'PositionSpecialties',
  inputShow: gql`
    query positionSpecialties($input: PositionSpecialtyQueryInput) {
      positionSpecialties(input: $input) {
        id
        __typename
      }
    }
  `,
  list,
  show,
  create,
  edit,
  options: {
    group: 'Misc',
    label: 'Position Specialties',
  },
};
